import { Paper, Stack } from "@mui/material";

import { DropzoneSingle } from "./Dropzone";
import { LocalFileRow } from "./FileRow";

export type AcceptedFormats = ("application/pdf" | "image/*")[] | undefined;

type UploadCardProps = {
  acceptedFormats: AcceptedFormats;
  description: string;
  files: File[] | undefined;
  handleFileChange: (file: File | undefined) => void;
  onRemoveFile: (file: File) => void;
  title: string;
};

export const UploadCard = ({
  acceptedFormats,
  description,
  files,
  handleFileChange,
  onRemoveFile,
  title,
}: UploadCardProps) => {
  return (
    <Paper className="p-4 shadow-elevation400">
      <h3 className="font-ds-headline-sm">{title}</h3>
      <p className="mt-1 min-h-8 text-lds-foreground-muted font-ds-body-regular-xs">{description}</p>
      <DropzoneSingle
        acceptedFormats={acceptedFormats}
        className="mt-4 h-25 w-full"
        handleFileChange={handleFileChange}
        hasIcon
      />
      {files && files.length > 0 && (
        <Stack className="mt-4 flex-col gap-2">
          {files?.filter(Boolean)?.map((file: File) => (
            <LocalFileRow
              className="px-2 py-1"
              file={file}
              isImage={false}
              key={file.name}
              removeFile={() => onRemoveFile(file)}
            />
          ))}
        </Stack>
      )}
    </Paper>
  );
};
